<template>
  <div id="app" :style="{ 'font-family': fontFamily }">
    <app-header />
    <router-view style="backgroundColor: #fbfbf9;min-height: 92vh;" />
  </div>
</template>

<script>
import Header from './components/header/header.vue'
export default {
  name: 'App',
  components: {
    'app-header': Header
  },
  data: function() {
    return {
      fontFamily: 'Montserrat'
    }
  },
  created() {
    this.$store.dispatch('authStore/initLoginToStore')
    // TODO: show message if API got problem
    this.$store.dispatch('packageStore/fetchPackages')
    this.$store.dispatch('languageStore/initLanguage')

    if (localStorage.getItem('token')) {
      this.$store.dispatch('authStore/fetchUserInfo')
    }

    this.$store.watch(
      (state, getters) => getters['languageStore/getLanguage'],
      (newValue, oldValue) => {
        if (newValue) {
          if (newValue === 'cn') {
            this.fontFamily = 'Noto Sans SC'
          } else {
            this.fontFamily = 'Montserrat'
          }
        }
      },
    )
  }
}
</script>

<style>

</style>
